type Translations = Record<string, any>;

const locales: Record<string, Translations> = {};
let currentLocale = "en";

const getByPath = (obj: any, path: string): any => {
    return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
};

const interpolate = (template: string, values: Record<string, any>): string => {
    return template.replace(/%\(([^)]+)\)s/g, (match, key) => {
        const value = values[key];
        if (value === undefined || value === null) return match;
        return String(value);
    });
};

const Counterpart = {
    registerTranslations(locale: string, translations: Translations) {
        locales[locale] = translations || {};
    },
    setLocale(locale: string) {
        currentLocale = locale || "en";
    },
    getLocale() {
        return currentLocale;
    },
    translate(key: string, values: Record<string, any> = {}) {
        const localeTranslations = locales[currentLocale] || locales.en || {};
        const raw = getByPath(localeTranslations, key);
        const text = typeof raw === "string" ? raw : key;
        return interpolate(text, values);
    },
};

export default Counterpart;
